import { Checkbox, FormControlLabel } from '@mui/material';

interface CheckboxComponentProps {
  label: string;
  value?: boolean;
  disabled?: boolean;
  onChange: (val: boolean) => void;
}

const CheckboxComponent = ({
  label,
  value,
  disabled,
  onChange,
}: CheckboxComponentProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          disabled={disabled}
          checked={value}
          onChange={({ target: { checked } }) => onChange(checked)}
        />
      }
      label={label}
    />
  );
};

export default CheckboxComponent;
